export const messages = {
  en_us: require("@/locale/lang/en_US.json"),
  id_id: require("@/locale/lang/id_ID.json"),
  th_th: require("@/locale/lang/th_TH.json"),
  ms_my: require("@/locale/lang/ms_MY.json"),
  es_es: require("@/locale/lang/es_ES.json"),
  zh_yd: require("@/locale/lang/te_IN.json"),
  zh_cn: require("@/locale/lang/zh_CN.json"),
  zh_hk: require("@/locale/lang/zh_HK.json"),
  vi_vn: require("@/locale/lang/vi_VN.json"),
  ja_jp: require("@/locale/lang/ja_JP.json"),
  ko_kr: require("@/locale/lang/ko_KR.json"),
  pt_pt: require("@/locale/lang/pt_pt.json"),
  it_it: require("@/locale/lang/it_IT.json"),
};
// 英语 西班牙语 印尼语 日语 韩语 马来语 葡萄牙语 印地语 泰语 越南语 粤语
export const lang_list = {
    // pt_pt:'Português',
    // id_id:'Indonesia',
    en_us:'English',
    it_it:"Italiano",
    // th_th:'ภาษาไทย',
    // ms_my:'Melayu',
    // es_es:'español',
    // zh_yd:'हिंदी',
    // zh_cn:'简体中文',
    // zh_hk:'繁体中文',
    // vi_vn:'Tiếng Việt',
    // ja_jp:'日本語',
    // ko_kr:'한국어'
}
export const langDefault = () => {
  lang = "it_it"
  localStorage.setItem("lang", lang);
}
let lang = localStorage.getItem("lang");
if (!lang || !messages[lang]) {
  langDefault();
}
export { lang };
